<template>
  <div>
    <v-navigation-drawer v-model="drawer" app>
      <nav-draver></nav-draver>
    </v-navigation-drawer>
    <v-app-bar app color="indigo" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <!--      <v-img src="src/assets/logo.png" contain></v-img>-->
      <v-img
        alt="Gyuszigumi logo"
        class="shrink mr-2"
        contain
        :src="img"
        transition="scale-transition"
        width="40"
      />
      <v-toolbar-title>Gyuszigumi</v-toolbar-title>
    </v-app-bar>
  </div>
</template>

<script>
import NavDrawer from "@/components/NavDrawer";

export default {
  name: "AppBar",
  components: {
    "nav-draver": NavDrawer
  },
  data: function() {
    return {
      drawer: false,
      img: require("@/assets/logo.png")
    };
  }
};
</script>

<style scoped></style>
